var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.4 4.383a2.1 2.1 0 0 0-2.1 2.1v11.2c0 1.16.941 2.1 2.1 2.1h15.2a2.1 2.1 0 0 0 2.1-2.1v-11.2a2.1 2.1 0 0 0-2.1-2.1zM20.3 6.71v-.226a.7.7 0 0 0-.7-.7H4.4a.7.7 0 0 0-.7.7v.226l8.3 5.533zM3.7 8.39v9.292a.7.7 0 0 0 .7.7h15.2a.7.7 0 0 0 .7-.7V8.391l-7.91 5.275a.7.7 0 0 1-.777 0z",
  clipRule: "evenodd"
})));
export default SvgMail;